// Domains that require proxying to bypass 403 errors
const PROXY_DOMAINS = [
  "cbu01.alicdn.com",
  "img.alicdn.com",
  "sc01.alicdn.com",
  "sc02.alicdn.com",
  "sc03.alicdn.com",
  "sc04.alicdn.com",
];

/**
 * Checks if a URL is from a domain that requires proxying
 */
export function needsImageProxy(url: string): boolean {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;

    // List of domains that require proxying
    const proxyDomains = [
      "cbu01.alicdn.com",
      "img.alicdn.com",
      "sc02.alicdn.com",
      "sc01.alicdn.com",
    ];

    return proxyDomains.includes(hostname);
  } catch {
    return false;
  }
}

/**
 * Constructs a proxy URL for images that need it
 */
export function getProxiedImageUrl(originalUrl: string): string {
  if (!needsImageProxy(originalUrl)) {
    return originalUrl;
  }

  const encodedUrl = encodeURIComponent(originalUrl);
  // Use relative URL so it works in both dev and production
  return `/api/image-proxy?url=${encodedUrl}`;
}

/**
 * Gets the appropriate image URL (proxied if needed, original if not)
 * Returns a fallback placeholder if URL is invalid
 */
export function getImageUrl(url?: string): string {
  if (!url) return "/images/default-placeholder.png";

  // Force proxy usage for all Alibaba domains (for testing production behavior)
  if (needsImageProxy(url)) {
    return getProxiedImageUrl(url);
  }

  return url;
}
